const Cotizador = () =>
    import("@/views/cotizador/Cotizador");

export const CotizadorRoute = {
    path: "/CotizadorFianzas",
    component: Cotizador,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",       
        breadcrumb: [
            {
                text: "Cotizador Fianzas",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker","aps_executive","aps_promotor"]
    }
};